(function () {
  'use strict';

  function initExploreProducts(root) {
    var tabs = root.querySelectorAll('[data-xp-tab]');
    var panels = root.querySelectorAll('[data-xp-panel]');
    var strip = root.querySelector('[data-xp-tabs]');
    var prev = root.querySelector('.xp__tabarrow--prev');
    var next = root.querySelector('.xp__tabarrow--next');

    if (!tabs.length || !panels.length) return;

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var index = tab.getAttribute('data-xp-tab');

        tabs.forEach(function (t) {
          t.classList.toggle('is-active', t === tab);
        });
        panels.forEach(function (p) {
          p.classList.toggle('is-active', p.getAttribute('data-xp-panel') === index);
        });

        tab.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      });
    });

    if (strip && prev && next) {
      var step = function () {
        return Math.round(strip.clientWidth * 0.6);
      };
      prev.addEventListener('click', function () {
        strip.scrollBy({ left: -step(), behavior: 'smooth' });
      });
      next.addEventListener('click', function () {
        strip.scrollBy({ left: step(), behavior: 'smooth' });
      });
    }
  }

  function boot() {
    document.querySelectorAll('.xp').forEach(initExploreProducts);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('.xp');
    if (el) initExploreProducts(el);
  });
})();